import React, { useState } from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function B2bRechargeSoftware() {
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const faqs = [
    {
      question: "What is Mokshiq B2B Mobile Recharge Software?",
      answer:
        "B2B Mobile Recharge Software by Mokshiq (Rakle Service Private Limited) is a turnkey portal platform that allows distributors and master distributors to manage retailers, set multi-tier commission structures, and route multi-operator recharges."
    },
    {
      question: "Does it support automated LAPU balance switching?",
      answer:
        "Yes, our B2B portal comes built-in with intelligent automatic LAPU switching to guarantee 99.9% uptime across Jio, Airtel, Vi, and BSNL."
    },
    {
      question: "Can I use my own domain and company logo?",
      answer:
        "Absolutely. It is a 100% White-Label solution branded with your domain name, company logo, and customized color themes."
    }
  ];

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitStatus('');

    try {
      const formBody = new URLSearchParams();
      // User-entered fields
      formBody.append('name', formData.name);
      formBody.append('phone', formData.phone);
      // Fixed API fields (matching the curl reference exactly)
      formBody.append('action', 'ADD');
      formBody.append('email', 'vinita');
      formBody.append('company_url', 'retailer.mokshiq.in');
      formBody.append('subject', 'test');
      formBody.append('message', 'pleae share');

      // NOTE: the curl included an `Origin` header, but that is a
      // "forbidden header name" for browser fetch/XHR — browsers set
      // Origin automatically based on where the page is actually
      // hosted, and will silently ignore any attempt to set it
      // manually via JS. So it is intentionally left out here; if the
      // API strictly checks Origin, this call will only succeed when
      // run from a domain the API allows (e.g. csc.kryntiq.com).
      const response = await fetch('https://api.mokshiq.in/enquiry-action', {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoyMDg1LCJjbGllbnRfaWQiOiJjc2Mua3J5bnRpcS5jb20iLCJqdGkiOiIzN2EwNjYyYi04NDg1LTQ0YWUtOTg0ZS03ZjNhOWZiYzMzYjgiLCJpYXQiOjE3ODc0MDA3MTUsImV4cCI6MjEwMjc2MDcxNX0.EhMHAZw7sXm1Q6TCtRlryqBDTwQ68XSHMOq_MQ3B-kk',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formBody.toString()
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      const result = await response.json();
      console.log('B2B Demo API Response:', result);

      setSubmitStatus('success');
      // Clear form after successful submission
      setFormData({ name: '', phone: '' });
    } catch (error) {
      console.error('B2B Demo Request Error:', error);
      setSubmitStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        {/* Page Header */}
        <section
          className="page_header text-center bg-dark section_decoration overflow-hidden py-5"
          style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}
        >
          <div className="container">
            <span
              className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold"
              style={{ letterSpacing: '1px' }}
            >
              <i className="fa-solid fa-mobile-screen me-2"></i>
              Software Solution
            </span>
            <h1 className="page_title text-white mb-3">
              B2B Mobile Recharge Software
            </h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Turnkey B2B portal platform for Master Distributors, Retailers, and
              API Resellers powered by{' '}
              <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/services">Softwares</a>
              </li>
              <li className="active">
                <a href="#!">B2B Recharge Software</a>
              </li>
            </ul>
          </div>
        </section>

        {/* Features + Demo Form */}
        <section className="section_space bg-white">
          <div className="container">
            <div className="row align-items-center g-4 mb-5">
              {/* Features */}
              <div className="col-lg-6">
                <div className="p-4 p-lg-5 bg-light rounded-4 shadow-sm border">
                  <h3 className="h4 text-dark font-weight-bold mb-3">
                    B2B Retailer &amp; Distributor Portal Features
                  </h3>
                  <ul className="list-unstyled">
                    <li className="mb-3 d-flex align-items-start">
                      <i className="fa-solid fa-circle-check text-success me-3 mt-1 fa-lg"></i>
                      <div>
                        <strong>Multi-Level Admin Hierarchy:</strong>{' '}
                        Manage Master Distributors, Distributors, Retailers, and
                        API Clients from a single admin panel.
                      </div>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <i className="fa-solid fa-circle-check text-success me-3 mt-1 fa-lg"></i>
                      <div>
                        <strong>Custom Commission Slabs:</strong>{' '}
                        Set flat or percentage margin slabs for each operator and
                        user level.
                      </div>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <i className="fa-solid fa-circle-check text-success me-3 mt-1 fa-lg"></i>
                      <div>
                        <strong>Automated Wallet Top-Up:</strong>{' '}
                        Integrated UPI Payment Gateway for instant self-service
                        wallet credit.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Demo Form */}
              <div className="col-lg-6">
                <div className="p-4 p-lg-5 bg-dark text-white rounded-4 shadow-lg">
                  <h4 className="text-warning font-weight-bold mb-3">
                    Request B2B Portal Demo
                  </h4>

                  {/* Success Message */}
                  {submitStatus === 'success' && (
                    <div className="alert alert-success py-2 small mb-3" role="alert">
                      <i className="fa-solid fa-circle-check me-2"></i>
                      Demo request submitted successfully. Our team will contact
                      you shortly.
                    </div>
                  )}

                  {/* Error Message */}
                  {submitStatus === 'error' && (
                    <div className="alert alert-danger py-2 small mb-3" role="alert">
                      <i className="fa-solid fa-triangle-exclamation me-2"></i>
                      Something went wrong. Please try again.
                    </div>
                  )}

                  <form onSubmit={handleFormSubmit}>
                    {/* Business Name */}
                    <div className="mb-3">
                      <label className="form-label small text-white-50">
                        Business Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleFormChange}
                        className="form-control"
                        placeholder="Your Company Name"
                        required
                      />
                    </div>

                    {/* Mobile Number */}
                    <div className="mb-3">
                      <label className="form-label small text-white-50">
                        Mobile Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleFormChange}
                        className="form-control"
                        placeholder="+91 7311104571"
                        required
                      />
                    </div>

                    {/* Submit */}
                    <button
                      type="submit"
                      disabled={submitting}
                      className="btn btn-warning w-100 font-weight-bold py-2 text-dark"
                    >
                      {submitting ? (
                        <>
                          Submitting...{' '}
                          <i className="fa-solid fa-spinner fa-spin ms-2"></i>
                        </>
                      ) : (
                        <>
                          Get B2B Demo Access{' '}
                          <i className="fa-solid fa-arrow-right ms-2"></i>
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <FAQ
          faqList={faqs}
          title="B2B Recharge Software FAQs"
          subtitle="Frequently asked questions about our B2B Recharge Portal."
        />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default B2bRechargeSoftware;